module.exports = __webpack_public_path__ + "img/styria-digital-development.3be6a0ab.svg";